/**
 * Shared timer mode constants for client and server.
 * Used by web, desktop, and future mobile apps.
 */

export const TIME_TO_WORK = "time-to-work";
export const TIME_TO_NEXT_BREAK = "time-to-next-break";
export const TIMER_MODES = [TIME_TO_WORK, TIME_TO_NEXT_BREAK] as const;
export type TimerMode = (typeof TIMER_MODES)[number];

/** Object form for convenient access (e.g. TIMER_MODES_OBJ.TIME_TO_WORK) */
export const TIMER_MODES_OBJ = {
  TIME_TO_NEXT_BREAK: TIME_TO_NEXT_BREAK,
  TIME_TO_WORK: TIME_TO_WORK,
} as const;

export const DEFAULT_FOCUS_TIME = 25;
export const DEFAULT_BREAK_TIME = 5;
export const DEFAULT_DEFAULT_TASK_DURATION = 30;
export const DEFAULT_NUDGE_INTERVAL = 5;
export const DEFAULT_TIMER_MODE = TIME_TO_WORK;

export const DEFAULT_START_TIME = "08:00";
export const DEFAULT_END_TIME = "19:00";
